import {
  fetchObjects,
  FETCH_OBJECTS_FAILURE,
  FETCH_OBJECT_FAILURE,
} from './tableOnSteroids';
import { fetchCurrentCampaign } from './currentCampaign';
import { trackEvent } from '../../lib/analytics';
import axios from 'axios';
import { AGENTS_ENDPOINTS } from '../../../javascript/config/api';

export const APPLY_ACTION_SUCCESS = 'APPLY_ACTION_SUCCESS';
export const applyActionFailure = (error, opts) => ({
  type: FETCH_OBJECT_FAILURE,
  error: error.message,
  opts,
});

export const applyBatchActionFailure = (error, opts) => ({
  type: FETCH_OBJECTS_FAILURE,
  error: error.message,
  opts,
});


export const applyAction = (actionType, opts = {}) => async dispatch => {
  const { tableId, extraParams, onSuccess, onError, id } = opts;
  const url = `/manager/user_offers/${id}/apply_action/${actionType}.json`;
  const token = $('meta[name="csrf-token"]').attr('content');
  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: extraParams ? JSON.stringify(extraParams) : null,
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' },
    });

    const data = await response.json();

    trackEvent(actionType, 'Campaign Management', { actionType: 'Group Action', influencerNumber: 1 });

    if (onSuccess) {

      onSuccess(data);
    }

    if (tableId) {
      dispatch(
        fetchObjects({
          tableId,
          appendOldState: true,
          updatedObjects: data,
        }),
      );
    }

    dispatch(fetchCurrentCampaign({ skip_loading: true }));
  } catch (error) {
    if (onError) {
      onError(error);
    }
    dispatch(applyActionFailure(error, opts));
  }
};

export const applyBatchAction = (
  actionType,
  opts = {},
) => async dispatch => {
  const { ids, tableId, extraParams = {}, onSuccess, onError } = opts;
  const url = `/manager/user_offers/apply_batch_action/${actionType}.json`;
  const token = $('meta[name="csrf-token"]').attr('content');
  const params = { user_offer_ids: ids, ...extraParams };

  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' },
    });

    const data = await response.json();

    trackEvent(actionType, 'Campaign Management', { actionType: 'Group Action', influencerNumber: ids.length });

    if (onSuccess) {
      onSuccess(data);
    }

    if (tableId) {
      dispatch(
        fetchObjects({
          tableId,
          appendOldState: true,
          updatedObjects: data,
        }),
      );
    }

    dispatch(fetchCurrentCampaign({ skip_loading: true }));

    return true;
  } catch (error) {
    if (onError) {
      onError(error);
    }
    dispatch(applyBatchActionFailure(error, opts));
  }
};

export const applyClientAction = (actionType, opts = {}) => async dispatch => {
  const { extraParams, id, onSuccess, tableId } = opts;
  axios.put(AGENTS_ENDPOINTS.USER_OFFERS.APPLY_ACTION(id, actionType), extraParams)
    .then((response) => {
      const data = response.data;
      if (tableId) {
        dispatch(
          fetchObjects({
            tableId,
            appendOldState: false,
            updatedObjects: data,
            callback: () => {
              if (onSuccess) { onSuccess() }
            },
            isAgentDashboard: true
          }),
        );
      }
    })
    .catch(() => console.log('Error updating the value.'));
}
